__turbopack_context__.v({
  "form": "LoginModal-module-scss-module__mMKFCa__form",
  "link": "LoginModal-module-scss-module__mMKFCa__link",
});
